import { Component } from 'vue-property-decorator';
import ContactRelationCategoryTable from '@contacts/components/tables/contact-relation-category-table/contact-relation-category-table.vue';
import Vue from 'vue';

@Component({
  name: 'bpc-contact-relation-categories',
  components: {
    'bpc-contact-relation-category-table': ContactRelationCategoryTable,
  },
})
export default class ContactRelationCategories extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
